var exports = {
  "kL": "x61f99309--97183b--container",
  "Sl": "x61f99309--97183b--image",
  "Kk": "x61f99309--97183b--icon",
};

module.exports = exports;
